export default {
    SET_ALLSELFIES(state, selfies) {
      state.selfies = selfies
    },
    REMOVE_RECORD(state, itemId) {
      const userIndex = state.users.findIndex((u) => u.userID === itemId)
  
      state.users.splice(userIndex, 1)
    },
    UPDATE_SELFIE(state, data) {
      
      // const selfieIndex = state.selfies.findIndex((u) => u._id === data._id)
      // state.selfies[selfieIndex].status = 
  
    },
    APPROVE_USER(state, data) { 
      // const userIndex = state.users.findIndex((u) => u.userID === data)
  
      // state.users[userIndex].statue = true
    },
    REJECT_USER(state, data) { 
      const userIndex = state.users.findIndex((u) => u.userID === data)
  
      state.users[userIndex].statue = false
    }
  }
  